export const statusMap = {
  0: { type: "info", label: "已创建", value: 0 },
  1: { type: "warning", label: "进行中", value: 1 },
  2: { type: "success", label: "成功", value: 2 },
  3: { type: "danger", label: "异常", value: 3 },
  4: { type: "info", label: "已失效", value: 4 },
  5: { type: "modified", label: "已修改", value: 5 }
}; // 状态map
